/* Plantéa local recreation — shared site behaviour (owner: A1).
   Header (theme, fixed/transparent/shrink, burger overlay, active nav), cart count, scroll-in animations,
   fit-image sizing, parallax background mirrors, global email popup. No dependencies. */
(function () {
  'use strict';

  var doc = document, root = doc.documentElement, body = doc.body;
  var header = doc.getElementById('header');
  var CART_KEY = 'plantea.cart.v1';
  var POPUP_COOKIE = 'omnisend-form-68e843db1ddde27bc6f47caa-closed-at';
  var MOBILE_HEADER_MQ = window.matchMedia('only screen and (pointer: coarse) and (max-width: 1024px), screen and (max-width: 799px)');

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function throttleFrame(fn) {
    var queued = false;
    return function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fn(); }); };
  }

  /* ---------------- Header theme ----------------
     The original gives the header the first section's theme on some pages (e.g. bright on /404, light-bold on /about).
     Pages opt in with <body data-header-theme="…">; base.css maps the variables, this keeps the attribute in sync. */
  if (header && body.hasAttribute('data-header-theme')) {
    var ht = body.getAttribute('data-header-theme');
    header.setAttribute('data-section-theme', ht);
    if (ht) header.classList.add(ht);
  }

  /* ---------------- Active navigation item ---------------- */
  (function markActiveNav() {
    var path = location.pathname.replace(/\/+$/, '') || '/';
    $all('.header-nav-list .header-nav-item > a, .header-menu-nav-item > a').forEach(function (a) { // nav links only (the cart action also carries .header-nav-item)
      var href = a.getAttribute('href');
      if (!href || href === '/') return;
      if (path === href || path.indexOf(href + '/') === 0) {
        a.setAttribute('aria-current', 'page');
        var item = a.parentElement;
        if (item.classList.contains('header-nav-item')) item.classList.add('header-nav-item--active');
        if (item.classList.contains('header-menu-nav-item')) item.classList.add('header-menu-nav-item--active');
      }
    });
  })();

  /* ---------------- Header height, shrink on scroll ---------------- */
  var lastHeaderH = -1;
  function updateHeaderHeight() {
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    if (Math.abs(h - lastHeaderH) > 0.01) {
      lastHeaderH = h;
      root.style.setProperty('--header-height', h + 'px');
      root.style.setProperty('--header-fixed-top-offset', h + 'px');
      root.style.scrollPaddingTop = h + 'px'; // original keeps scroll-padding-top = header height
    }
  }
  // The original reacts late: ~100ms after leaving the top, ~400ms after returning to it.
  var shrinkTimer = null, shrinkTarget = null;
  function updateShrink(immediate) {
    if (!header) return;
    var shrink = (window.pageYOffset || root.scrollTop) > 0;
    if (immediate === true) { header.classList.toggle('shrink', shrink); return; }
    if (shrink === header.classList.contains('shrink')) { if (shrinkTimer) { clearTimeout(shrinkTimer); shrinkTimer = null; shrinkTarget = null; } return; }
    if (shrinkTarget === shrink) return;
    if (shrinkTimer) clearTimeout(shrinkTimer);
    shrinkTarget = shrink;
    shrinkTimer = setTimeout(function () { shrinkTimer = null; shrinkTarget = null; header.classList.toggle('shrink', (window.pageYOffset || root.scrollTop) > 0); }, shrink ? 100 : 400);
  }
  if (header) {
    updateShrink(true);
    updateHeaderHeight();
    header.addEventListener('transitionend', updateHeaderHeight);
    if (window.ResizeObserver) new ResizeObserver(updateHeaderHeight).observe(header);
  }

  /* ---------------- Burger / overlay menu ---------------- */
  var burgers = $all('.header-burger-btn');
  function setMenu(open) {
    body.classList.toggle('header--menu-open', open);
    burgers.forEach(function (b) {
      b.classList.toggle('burger--active', open);
      var o = b.querySelector('.js-header-burger-open-title'), c = b.querySelector('.js-header-burger-close-title');
      if (o) o.hidden = open;
      if (c) c.hidden = !open;
    });
    // Focus stays within header + overlay while the menu is open (Tab never enters the page behind, as on the original).
    [doc.getElementById('page'), doc.getElementById('footer-sections')].forEach(function (el) { if (el) el.inert = open; });
  }
  burgers.forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); setMenu(!body.classList.contains('header--menu-open')); });
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && body.classList.contains('header--menu-open')) setMenu(false); });
  function onHeaderMqChange() { if (!MOBILE_HEADER_MQ.matches && body.classList.contains('header--menu-open')) setMenu(false); }
  if (MOBILE_HEADER_MQ.addEventListener) MOBILE_HEADER_MQ.addEventListener('change', onHeaderMqChange);
  else if (MOBILE_HEADER_MQ.addListener) MOBILE_HEADER_MQ.addListener(onHeaderMqChange);

  /* ---------------- Cart count (localStorage plantea.cart.v1 + plantea:cart-change) ---------------- */
  function readCartCount() {
    try {
      var data = JSON.parse(localStorage.getItem(CART_KEY) || 'null');
      if (!data || !Array.isArray(data.items)) return 0;
      return data.items.reduce(function (n, it) { return n + (parseInt(it && it.qty, 10) || 0); }, 0);
    } catch (e) { return 0; }
  }
  function renderCartCount(count) {
    $all('.sqs-cart-quantity').forEach(function (el) { el.textContent = String(count); });
    $all('.sqs-custom-cart').forEach(function (a) { a.classList.toggle('cart-quantity-zero', count === 0); a.setAttribute('aria-label', count + ' items in cart'); });
  }
  window.addEventListener('plantea:cart-change', function (e) {
    var c = e && e.detail && typeof e.detail.count === 'number' ? e.detail.count : readCartCount();
    renderCartCount(c);
  });
    window.PlanteaSite = window.PlanteaSite || {};
  window.PlanteaSite.refreshCartCount = function () { renderCartCount(readCartCount()); };

  /* ---------------- Scroll-in animations ----------------
     Mirrors tweak-global-animations (style fade, type slide, curve ease, detailed): every animated element gets
     preSlide/preFade with transition-delay = index × 0.006s (document order), then slideIn/fadeIn on entering the viewport. */
  var SLIDE = [
    '[data-animation-role="header-element"]', '[data-animation-role="image"]', '[data-animation-role="button"]',
    '#page .sqs-block-html .sqs-html-content > h1', '#page .sqs-block-html .sqs-html-content > h2', '#page .sqs-block-html .sqs-html-content > h3',
    '.list-item-content__title', 'footer .fe-block > .sqs-block > .sqs-block-content'
  ].join(',');
  var FADE = [
    '[data-animation-role="content"]',
    '.sqs-block-html .sqs-html-content > h4', '.sqs-block-html .sqs-html-content > p',
    '.list-item-content__description > p', '.summary-excerpt > p'
  ].join(',');
  function initAnimations() {
    var els = $all(SLIDE + ',' + FADE);
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting || en.intersectionRatio > 0) {
          var el = en.target;
          el.classList.add(el.classList.contains('preSlide') ? 'slideIn' : 'fadeIn');
          io.unobserve(el);
        }
      });
    }, { threshold: 0 }) : null;
    els = els.filter(function (el) { return !el.hasAttribute('data-no-animation'); });
    var step = els.length ? 0.6 / els.length : 0; // original: delay of the i-th element = i × (0.6s / N)
    els.forEach(function (el) {
      var slide = el.matches(SLIDE) && !el.matches('[data-animation-role="content"]');
      el.style.transition = 'none'; // snap to the hidden pre-state (no fade-out on load)
      el.classList.add(slide ? 'preSlide' : 'preFade');
    });
    void body.offsetHeight;
    els.forEach(function (el, i) {
      el.style.transition = '';
      el.style.transitionDelay = +(i * step).toFixed(6) + 's';
      if (io) io.observe(el); else el.classList.add(el.classList.contains('preSlide') ? 'slideIn' : 'fadeIn');
    });
  }

  /* ---------------- Fit images: size the container to the image's native aspect inside its block ---------------- */
  function sizeFitImages() {
    $all('.fluid-image-component-root[data-is-image-stretched="false"]').forEach(function (fr) {
      var c = fr.querySelector('.fluid-image-container'), img = c && c.querySelector('img');
      if (!img) return;
      var ar = 0, v = getComputedStyle(fr).getPropertyValue('--image-component-native-aspect-ratio').trim();
      if (v) { var p = v.split('/'); ar = parseFloat(p[0]) / parseFloat(p[1] || 1); }
      if (!ar) { var d = (img.getAttribute('data-image-dimensions') || '').split('x'); ar = parseFloat(d[0]) / parseFloat(d[1]); }
      if (!ar && img.naturalWidth) ar = img.naturalWidth / img.naturalHeight;
      if (!ar) return;
      var W = fr.clientWidth, H = fr.clientHeight;
      if (!W || !H) return;
      var w = W, h = W / ar;
      if (h > H) { h = H; w = H * ar; }
      c.style.width = w + 'px';
      c.style.height = h + 'px';
    });
  }

  /* ---------------- Parallax background mirrors (port of the parallax.js algorithm used by the original, speed 0.7) ---------------- */
  var SPEED = 0.7, mirrors = [];
  var TOUCH = window.matchMedia('(pointer: coarse)').matches || ('ontouchstart' in window); // not maxTouchPoints: touch-capable desktops still get parallax
  function initParallax() {
    $all('.page-section.has-background').forEach(function (sec) {
      var img = sec.querySelector('.section-background img');
      if (!img || sec.hasAttribute('data-no-parallax')) return;
      var src = (img.getAttribute('srcset') || '').split(',').pop().trim().split(' ')[0] || img.getAttribute('src');
      if (!src) return;
      var dims = (img.getAttribute('data-image-dimensions') || '').split('x').map(Number);
      var focal = (img.getAttribute('data-image-focal-point') || '0.5,0.5').split(',').map(Number);
      sec.setAttribute('data-parallax-original-element', '');
      if (TOUCH) {
        sec.style.backgroundImage = 'url("' + src + '")';
        sec.style.backgroundSize = 'cover';
        sec.style.backgroundPosition = 'center center';
        return;
      }
      var mirror = doc.createElement('div');
      mirror.className = 'parallax-mirror';
      var slider = doc.createElement('img');
      slider.className = 'parallax-slider';
      slider.alt = '';
      slider.src = src;
      mirror.appendChild(slider);
      body.insertBefore(mirror, body.firstChild);
      mirrors.push({ sec: sec, mirror: mirror, slider: slider, aspect: dims[0] && dims[1] ? dims[0] / dims[1] : 0, focal: focal });
      slider.addEventListener('load', function () { refreshParallax(); renderParallax(); });
    });
  }
  function refreshParallax() {
    var winH = window.innerHeight, docH = Math.max(body.scrollHeight, root.scrollHeight);
    mirrors.forEach(function (m) {
      var r = m.sec.getBoundingClientRect();
      m.top = r.top + window.pageYOffset; m.left = r.left + window.pageXOffset; m.w = r.width; m.h = r.height;
      var aspect = m.aspect || (m.slider.naturalWidth && m.slider.naturalWidth / m.slider.naturalHeight) || 1;
      var maxOffset = Math.min(m.top, docH - winH), minOffset = Math.max(m.top + m.h - winH, 0);
      var imageHeightMin = m.h + (maxOffset - minOffset) * (1 - SPEED) | 0;
      var imageOffsetMin = (m.top - maxOffset) * (1 - SPEED) | 0;
      if (imageHeightMin * aspect >= m.w) {
        m.iw = imageHeightMin * aspect | 0; m.ih = imageHeightMin; m.baseTop = imageOffsetMin;
        m.offLeft = -(m.iw - m.w) / 2 | 0;
      } else {
        m.iw = m.w; m.ih = m.w / aspect | 0; m.offLeft = 0;
        m.baseTop = imageOffsetMin - (m.ih - imageHeightMin) / 2 | 0;
      }
    });
  }
  function renderParallax() {
    var st = window.pageYOffset, sl = window.pageXOffset, sb = st + window.innerHeight;
    mirrors.forEach(function (m) {
      if (m.top === undefined) return;
      var visible = m.top + m.h > st && m.top <= sb;
      var mt = m.top - st;
      var s = m.mirror.style;
      s.visibility = visible ? 'visible' : 'hidden';
      s.top = mt + 'px'; s.left = (m.left - sl) + 'px'; s.width = m.w + 'px'; s.height = m.h + 'px';
      var ss = m.slider.style;
      ss.top = (m.baseTop - mt * (1 - SPEED)) + 'px'; ss.left = m.offLeft + 'px'; ss.width = m.iw + 'px'; ss.height = m.ih + 'px';
    });
  }

  /* ---------------- Email popup (Omnisend-style, global) ---------------- */
  function getCookie(name) {
    var m = doc.cookie.match(new RegExp('(?:^|; )' + name.replace(/[-.]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function initPopup() {
    var pop = doc.getElementById('omnisend-form-68e843db1ddde27bc6f47caa');
    if (!pop || getCookie(POPUP_COOKIE)) { if (pop) pop.parentNode.removeChild(pop); return; }
    if (window.Shopify && window.Shopify.designMode) {
      var showInEditor = function (on) { var el = doc.querySelector('.omnisend-popup'); if (el) { el.hidden = !on; el.classList.toggle('is-open', on); } };
      doc.addEventListener('shopify:section:select', function (e) { if (e.target.id === 'shopify-section-popup') showInEditor(true); });
      doc.addEventListener('shopify:section:deselect', function (e) { if (e.target.id === 'shopify-section-popup') showInEditor(false); });
      $all('[data-popup-close]', pop).forEach(function (b) { b.addEventListener('click', function () { showInEditor(false); }); });
      return;
    }
    var closed = false, lastFocus = null;
    function close() {
      if (closed) return; closed = true;
      doc.cookie = POPUP_COOKIE + '=' + encodeURIComponent(new Date().toISOString()) + '; path=/; max-age=' + (60 * 60 * 24 * 365);
      pop.parentNode && pop.parentNode.removeChild(pop);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    setTimeout(function () {
      if (closed || getCookie(POPUP_COOKIE)) { close(); return; }
      lastFocus = doc.activeElement;
      pop.hidden = false;
      var dlg = pop.querySelector('[role="dialog"]');
      if (dlg) dlg.focus({ preventScroll: true });
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
    }, 3000);
    $all('[data-popup-close]', pop).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
    // Clicking the dimmed overlay does NOT close the original popup. Tab is trapped inside the dialog.
    pop.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $all('input, button, a[href]', pop).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = doc.activeElement;
      if (e.shiftKey && (a === first || !pop.contains(a) || a.getAttribute('role') === 'dialog')) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !pop.contains(a))) { e.preventDefault(); first.focus(); }
    });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); // re-submitted below once valid
      var input = form.querySelector('input[type="email"]');
      var email = input ? input.value.trim() : '';
      if (!email || (input && !input.checkValidity())) { if (input) { input.classList.add('is-invalid'); input.focus(); } return; }
      doc.cookie = POPUP_COOKIE + '=' + encodeURIComponent(new Date().toISOString()) + '; path=/; max-age=' + (60 * 60 * 24 * 365);
      form.submit();
    });
  }

  /* ---------------- Boot ---------------- */
  function onScroll() { updateShrink(false); renderParallax(); }
  var onResize = throttleFrame(function () { updateHeaderHeight(); sizeFitImages(); refreshParallax(); renderParallax(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  function boot() {
    var sys = doc.querySelector('.system-page');
    if (sys && header) { var padSys = function () { sys.style.paddingTop = header.getBoundingClientRect().height + 'px'; }; padSys(); window.addEventListener('resize', padSys); window.addEventListener('load', padSys); }
    initAnimations();
    sizeFitImages();
    initParallax();
    refreshParallax(); renderParallax();
    initPopup();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(onResize);
      ro.observe(body);
      $all('.fluid-image-component-root[data-is-image-stretched="false"]').forEach(function (el) { ro.observe(el); });
    }
    window.addEventListener('load', onResize);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(onResize);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
